// import WMSStatusTag from './tag';
import WMSStatusTag from './tag-hoc';
export default WMSStatusTag;
